export enum ECountries {
  GetCountries = 'GetCountries',
  getStates = 'states',
}
